import React from 'react';
import './International.scss'
import { Lists, HeaderSwiper } from '@/components/mixins'
import '../../common/common.scss'
import { RelatedCases } from '@/components'
class International extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      headerDataLists: [
        { imgPath: require("img/Products/Internationalbanner.png"), imgHDPath: `${require("img/Products/Internationalbanner.png")} 1x,${require("img/Products/Internationalbanner@2x.png")} 2x,${require("img/Products/Internationalbanner@3x.png")} 3x`, attachURL: "/" }
      ],
      topdataLists: [
        {
          // title: '管控体系建设',
          data: '随着“一带一路”的深入推进以及中国资本快速走入国际舞台，青矩积极开拓国际工程业务市场，打造富有特色的工程咨询海外发展新格局，组建了一批包括英国皇家测量师、英国皇家特许建筑师、香港工料测量师等，精通国内外工程管理模式、工程造价管控及计价体系的专业团队，创造了公司产业发展新的制高点，并拓展了国际影响力。',
          imgPath: require("img/Products/Internationalpic1.png"), imgHDPath: `${require("img/Products/Internationalpic1.png")} 1x,${require("img/Products/Internationalpic1@2x.png")} 2x,${require("img/Products/Internationalpic1@3x.png")} 3x`
        },
      ],
      dataLists: [
        {
          title: '全方位服务',
          data: '青矩境外工程涵盖冶炼、矿山、水利水电、市政、港口、交通、民建等诸多领域。服务类型包括全过程造价咨询、全过程跟踪审计、工程量清单和控制价编制、结决算审计、专有专题咨询或审计等，在解决项目执行过程中的合同纠纷方面拥有独到的见解和高效的解决方案。',
          imgPath: require("img/Products/Internationalpic2.png"), imgHDPath: `${require("img/Products/Internationalpic2.png")} 1x,${require("img/Products/Internationalpic2@2x.png")} 2x,${require("img/Products/Internationalpic2@3x.png")} 3x`
        },
        {
          title: '战略合作伙伴',
          data: '青矩在立足于伴随国内企业投资、总承包等项目“搭船出海”走出去的同时，也在积极开展自我“造船出海”的工作，在马来西亚成立了海外分支机构。其战略合作伙伴天职国际会计师事务所（特殊普通合伙）是Baker Tilly International（BTI）中国大陆和香港的唯一成员所，BTI是全球排名第八位的国际会计组织，在全球125个国家和地区拥有149家成员机构，具备广阔的国际联系网络。',
          imgPath: require("img/Products/Internationalpic3.png"), imgHDPath: `${require("img/Products/Internationalpic3.png")} 1x,${require("img/Products/Internationalpic3@2x.png")} 2x,${require("img/Products/Internationalpic3@3x.png")} 3x`
        },
      ],
      caseList: [
        { imgs: require("img/Products/Internationalcase1.png"), name: "哈萨克斯坦阿斯塔纳世博会中国馆" },
        { imgs: require("img/Products/Internationalcase2.png"), name: "中广核铀业斯科有限公司湖山铀矿" },
        // { imgs: require("img/Products/Internationalcase3.png"), name: "华电捷宁斯卡娅燃气" },
        { imgs: require("img/Products/Internationalcase4.png"), name: "老挝万象至磨丁高速公路万象至万荣段工程" },
        { imgs: require("img/Products/Internationalcase5.png"), name: "神华国华爪哇燃煤发电工程" },
        { imgs: require("img/Products/Internationalcase6.png"), name: "新兴铸管印尼镍铁项目" },
        { imgs: require("img/Products/Internationalcase7.png"), name: "印尼巴厘岛电厂" },

        { imgs: require("img/Products/Internationalcase8.png"), name: "哈萨克斯坦阿斯塔纳轻轨工程" },
        { imgs: require("img/Products/Internationalcase9.png"), name: "几内亚阿玛利亚水电站" },
      ]
    }
  }
  render() {
    return (
      <main>
        <HeaderSwiper headerDataLists={this.state.headerDataLists}></HeaderSwiper>
        <div className="International">
          <h5 className='product-title'>国际业绩</h5>
          <Lists dataLists={this.state.topdataLists}></Lists>
          <h5 className='product-title'>服务优势</h5>
          <Lists dataLists={this.state.dataLists}></Lists>
          {/* <h5 className="product-title">相关案例</h5> */}
          <RelatedCases caseList={this.state.caseList} id={'International'} />
        </div>
      </main>
    )
  }
}
export default International
